export default __webpack_public_path__ + "static/media/nip_6.361b5156.jpg";